import { OnboardingRoutes } from "@src/routes/loggedIn/standardPageRoutes/onboardingRoutes";

export const OnboardingPageRoutes = [...OnboardingRoutes];
